import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { SeoSettingsModel } from '../models/seo-setting/seo.model';
import { ApiService } from './Common/api.service';
import { UrlHelperService } from './Common/urlhelper.service';

@Injectable({
  providedIn: 'root'
})
export class SeoSettingService {

  constructor(private _api:ApiService) { 
    this.seoTitleMethod = this.seoTitleSubject.asObservable();
    this.seoDescriptionMethod = this.seoDescriptionSubject.asObservable();
    this.seoKeywordMethod = this.seoKeywordSubject.asObservable();
  }

  seoUpdateProduct(seoUpdateProduct: SeoSettingsModel) {    
    return this._api.post(UrlHelperService.seoUpdateProductEndPoint, seoUpdateProduct)
  }

  getSeoProductById(productId) {
    return this._api.post(UrlHelperService.getSeoProductEndPoint + productId)
  }

  //save seo settings
  seoTitleMethod: Observable<any>;
  private seoTitleSubject = new Subject<any>();

  setTitle(title) {            
      this.seoTitleSubject.next(title);
  }

  seoDescriptionMethod: Observable<any>;
  private seoDescriptionSubject = new Subject<any>();

  setDescription(description) {
    this.seoDescriptionSubject.next(description);
  }

  seoKeywordMethod: Observable<any>;
  private seoKeywordSubject = new Subject<any>();
  
  setKeyword(keyword) {
    this.seoKeywordSubject.next(keyword);
  }
}
